import { Component, OnInit, Output, EventEmitter, Input, NgModule } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WmsmStatementQueryWHQComponent } from 'src/app/WMSM-Pages/wmsm-StatementQueryWHQ/wmsm-StatementQueryWHQ.component';
import { WmsmStatementMaintainWHQComponent } from 'src/app/WMSM-Pages/wmsm-StatementMaintainWHQ/wmsm-StatementMaintainWHQ.component';
import { WmsmStatementAbnormalWHQComponent } from 'src/app/WMSM-Pages/wmsm-StatementabnormalWHQ/wmsm-StatementabnormalWHQ.component';
import { delay } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
interface SiteDto {
  siteCode: string;
  // 其他属性...
}


@Component({
  selector: 'app-wmsm-WHQRtconditions',
  templateUrl: './wmsm-WHQRtconditions.component.html',
  styleUrls: ['./wmsm-WHQRtconditions.component.scss'],
  providers: []
})
export class WmsmWHQRtConditionsComponent implements OnInit {
  Role: any;
  validateForm: FormGroup;
  SiteList: any;
  VendorList: any;
  BuyerList: any;
  SiteCache: any;
  VendorCache: any;
  BuyerCache: any;
  dataCache: any;
  UserRequestlimits: boolean = true;
  filterCache: any;
  userOptionList = [];
  disabledrtamont: boolean = false;
  BillingStatusLabels: string[] = [];
  BillingStatusOptions = [
    { nzLabel: 'NotRt', nzValue: '0' },
    { nzLabel: 'NotInvoice', nzValue: '1' },
    { nzLabel: 'Ongoing', nzValue: '2' },
    { nzLabel: 'Reject', nzValue: 'Reject' },
    { nzLabel: 'Paymenting', nzValue: '3' },
  ];
  //從外部輸入
  @Input() WHQKey: string;
  //监听条件区数值改变，改变则往下传值
  @Output() listenForm = new EventEmitter();
  //实现查询时/点击时，条件区小三角形收缩
  @Input() isShowCondition: boolean;
  //user的权限控制
  @Input() show: boolean;
  //实现查询时/点击时，条件区小三角形收缩
  @Output() outQuery = new EventEmitter();
  loading: boolean = false;
  All: any;
  //按需求控制三个条件区是否需要显示
  @Input() ShowSite: boolean = true;
  @Input() ShowVendor: boolean = true;
  @Input() ShowBuyer: boolean = true;
  @Input() ShowTime: boolean = true;
  @Input() ShowPONO: boolean = true;
  @Input() ShowApplyDept: boolean = true;
  @Input() ShowNotInvoice: boolean = true;
  @Input() ShowInvoiceNo: boolean = true;
  @Input() ShowPANO: boolean = true;
  @Input() ShowBillingStatus: boolean = true;
  @Input() maintainNotInvoice: boolean = false;
  @Input() Query: boolean = true;
  @Input() ShowSend: boolean = true;
  @Input() ShowSecondQuery: boolean = true;
  @Input() ShowSecondDown: boolean = true;
  @Input() ShowSecondExport: boolean = true;
  @Input() Showagree: boolean = true;
  @Input() showSave: boolean = true;
  @Input() Showreject: boolean = true;

  isAllowSend = false;
  constructor(

    private fb: FormBuilder,
    private AuthService: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private StatementQuery: WmsmStatementQueryWHQComponent,
    private StatementMaintain: WmsmStatementMaintainWHQComponent,
    private StatementAbnormal: WmsmStatementAbnormalWHQComponent,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    if (!this.show) {
      this.UserRequestlimits = false;
    }
    this.validateForm = this.fb.group({
      Site: [''],
      Vendor: [[]],
      Buyer: [[]],
      PONO: [''],
      StatementMonth: [''],
      InvoiceNo: [''],
      NotInvoice: [''],
      PANO: [''],
      BillingStatus: [[]],
      WhetherInvoice: [''],
      applyDept: ['']
    });
    this.GetResDto();
    this.setAllowSend();
  }

  setAllowSend() {
    this.isAllowSend = false;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetWHQRole.url}`;
    this.WebApiService.doGet(url).subscribe(res => {
      const roles = res.data as string[];
      if (roles.some(role => ['0', '3', '4'].includes(role.toString()))) {
        this.isAllowSend = true;
      }
    });
  }


  GetResDto(): Promise<void> {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetTwCondition.url}`;
    return new Promise((resolve, reject) => {
      this.WebApiService.doPost(url, "").subscribe(
        (res) => {
          var sitelist = res.data.siteListDto
          if (res.status === "200" && sitelist.length != 0) {
            const today = new Date();
            const lastYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
            this.dataCache = res.data;
            this.VendorCache = res.data.vendorListDto;
            this.SiteList = res.data.siteListDto.sort(this.compare);
            //this.validateForm.controls['Site'].setValue(res.data.siteListDto[0].siteCode);
            this.validateForm.controls['StatementMonth'].setValue([lastYear, today]);
            this.valuehandleChange();
            resolve();
          } else if (res.status === "200" && sitelist.length == 0) {
            this.translate.get('TemporaryUnconditionalZoneInformation').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            reject()
          }
          else if (res.status === "0000") {
            this.NzMessageService.error(res.msg);
            reject()
          }
          this.loading = false;
        },

        (error) => {
          this.NzMessageService.error(error.msg);
          this.loading = false;
        }
      );
    })
  }


  valuehandleChanges(): void {
    let value = {};
    Object.keys(this.validateForm.controls).forEach((key) => {
      if (key === 'Buyer') {
        this.validateForm.controls[key].value.includes('ALL')
          ? (value[key] = this.BuyerList.map((item) => item.buyer))
          : (value[key] = this.validateForm.controls[key].value);
      }
      else if (key === 'Vendor') {
        this.validateForm.controls[key].value.includes('ALL')
          ? (value[key] = this.VendorCache.map((item) => item.vendorCode))
          : (value[key] = this.validateForm.controls[key].value);
      }
      else {
        value[key] = this.validateForm.controls[key].value;
      }
    });
    this.listenForm.emit(value);
  }

  valuehandleChange(): void {

    let value = {};
    Object.keys(this.validateForm.controls).forEach((key) => {
      value[key] = this.validateForm.controls[key].value;
    });

    this.BillingStatusLabels = this.validateForm.controls['BillingStatus'].value.map(value => {
      const option = this.BillingStatusOptions.find(option => option.nzValue === value);
      const translatedLabel = this.translate.instant(option.nzLabel); // 根据当前语言翻译标签文本
      return translatedLabel;
    }).slice(1);
    this.listenForm.emit(value);
  }



  userSearch(event) {
    this.loading = true
    event = event.trim().toUpperCase();
    if (event.length > 5) {
      const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.QueryUser.url}` + event;
      setTimeout(() => {
        this.WebApiService.doGet(url).toPromise().then(
          (res) => {
            this.loading = true;
            this.userOptionList = res.data.slice(0, 10);

            this.loading = false
          },
          (error) => {
            this.NzMessageService.error(error.msg);
            this.loading = false
          }
        );
      }, 800);

    }
    this.loading = false
  }



  onPageChangeQuery() {
    if (this.WHQKey == 'StatementQueryWHQ') {
      this.StatementQuery.getResultData()
    }
    if (this.WHQKey == "StatementMaintainWHQ") {
      this.StatementMaintain.getResultData()
    }
    if (this.WHQKey == "StatementabnormalWHQ") {

      this.StatementAbnormal.onSearch()
    }
  }

  onPageChangeDownload() {
    if (this.WHQKey == 'StatementQueryWHQ') {
      this.StatementQuery.exportTableToExecl()
    }
    if (this.WHQKey == "StatementMaintainWHQ") {
      this.StatementMaintain.DownloadQueryStatementMaintainExcel()
    }
    if (this.WHQKey == "StatementabnormalWHQ") {
      this.StatementAbnormal.DownloadQueryStatementAbnormalExcel()
    }
  }

  Refresh() {
    this.StatementQuery.Refresh('Warning')
  }

  SendStatementNotification() {
    this.StatementQuery.SendStatementNotification();
  }

  clickApproved() {
    this.StatementMaintain.clickApproved();
  }

  showmodal() {
    this.StatementMaintain.showmodal();
  }

  VendorSearch(event) {
    if (event.length > 1) {
      const params = {
        Inputdata: event,
        SiteNo: this.validateForm.controls['Site'].value
      };
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetVendorListAsync.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          this.VendorList = res
        },
        (error) => {
          this.NzMessageService.error(error.msg);
        }
      );
    }
  }

  BuyerSearch(event) {
    if (event.length > 2) {
      const params = {
        Inputdata: event,
        SiteNo: this.validateForm.controls['Site'].value
      };
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetBuyerListAsync.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          this.BuyerList = res
        },
        (error) => {
          this.NzMessageService.error(error.msg);
        }
      );
    }
  }
  compare(a: SiteDto, b: SiteDto): number {
    const nameA = a.siteCode.toUpperCase(); // 忽略大小写进行比较
    const nameB = b.siteCode.toUpperCase();

    if (nameA < nameB) {
      return -1;  // a 在 b 前面
    }
    if (nameA > nameB) {
      return 1;  // a 在 b 后面
    }
    return 0;  // 名称相同
  }

}
